module.exports = __webpack_public_path__ + "R.svg?fad05c8232b36c0ef327b9701b9afb16";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/R.svg
// module id = 64
// module chunks = 0